import Login from "../components/Login";

const LoginPage = () => {
   return (
      <div>
         <Login />
      </div>
   );
};

export default LoginPage;
